<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57 15h-7.86a2.51 2.51 0 01-2.08-1.11l-2.66-4A2 2 0 0042.73 9H21.27a2 2 0 00-1.67.89l-2.66 4A2.51 2.51 0 0114.86 15H7a2 2 0 00-2 2v40a2 2 0 002 2h50a2 2 0 002-2V17a2 2 0 00-2-2zm-1 41H8V18h6.86a5.52 5.52 0 004.58-2.45L21.8 12h20.4l2.36 3.55A5.52 5.52 0 0049.14 18H56z"/><path d="M32 23.5A13.5 13.5 0 1045.5 37 13.52 13.52 0 0032 23.5zm0 24A10.5 10.5 0 1142.5 37 10.51 10.51 0 0132 47.5z"/><circle cx="15.5" cy="23.5" r="2.5"/></svg>